module.exports = __webpack_public_path__ + "img/logoAmsa.91ef5e5d.png";